import type { CapitalGlobalProposalStep1FormApi } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.types';
import { CAPITAL_GLOBAL_PROPOSAL_ADDRESS_FIELD_NAMES } from '@/features/proposals/components/capital-global/constants/capital-global-proposal-address-field-names.constant';

export function clearCapitalGlobalCorrespondenceFields(
  form: CapitalGlobalProposalStep1FormApi
): void {
  const fields = CAPITAL_GLOBAL_PROPOSAL_ADDRESS_FIELD_NAMES.correspondence;
  form.setFieldValue(fields.cep, '');
  form.setFieldValue(fields.street, '');
  form.setFieldValue(fields.number, '');
  form.setFieldValue(fields.complement, '');
  form.setFieldValue(fields.neighborhood, '');
  form.setFieldValue(fields.city, '');
  form.setFieldValue(fields.state, '');
}
